export default __webpack_public_path__ + "static/media/logo.a3457b29.svg";